import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { Params } from '../models/params';
import { ParamsSet } from '../models/params-set';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ParamsService extends CrudService implements AdvancedService<Params> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Params>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Params`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Params>(Params, x);
                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Params/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(paramsId: number, params: Params): Observable<Params> {
        // Appel de la Web Api
        return this.http.put<Params>(this.baseUrl + `/api/Params/${paramsId}`, params, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return Params.from(x);
            })
        );
    }

    delete(paramsId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<Params>(this.baseUrl + `/api/Params/${paramsId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(params: Params): Observable<Params> {
        // Appel de la Web Api
        return this.http.post<Params>(this.baseUrl + `/api/Params`, params, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return Params.from(x);
            })
        );
    }

    get(paramsId: number): Observable<Params> {
        // Appel de la Web Api
        return this.http.get<Params>(this.baseUrl + `/api/Params/${paramsId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return Params.from(x);
            })
        );
    }

    /**
     * Récupère le jeu de paramètres d'un utilisateur
     * @param userId Identifiant de l'utilisateur
     * @returns Retourne un jeu de paramètres
     */
    getForUser(userId: string): Observable<ParamsSet> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.get<ParamsSet>(this.baseUrl + `/api/organizations/${this.connectedUser.organization.id}/paramssets?userId=${userId}`, httpOptions).pipe(map((x) => x));
    }
}
